import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export interface StickyTabsBarProps {
  children: ReactNode;
  className?: string;
}

export function StickyTabsBar({ children, className }: StickyTabsBarProps) {
  return (
    <div
      className={cn(
        "sticky z-10 -mx-8 border-b border-gray-200 bg-gray-50 px-8 py-3",
        className,
      )}
      style={{ top: "var(--detail-header-offset, 0px)" }}
    >
      {children}
    </div>
  );
}
